import { render, staticRenderFns } from "./v-radio.vue?vue&type=template&id=12656855&scoped=true&"
import script from "./v-radio.vue?vue&type=script&lang=js&"
export * from "./v-radio.vue?vue&type=script&lang=js&"
import style0 from "./v-radio.vue?vue&type=style&index=0&id=12656855&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12656855",
  null
  
)

export default component.exports